import { render, staticRenderFns } from "./ShopListPage.vue?vue&type=template&id=96a30a6a&scoped=true&"
import script from "./ShopListPage.vue?vue&type=script&lang=js&"
export * from "./ShopListPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopListPage.vue?vue&type=style&index=0&id=96a30a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a30a6a",
  null
  
)

export default component.exports